import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import TicketAttribute from 'models/ticket-attribute/ticket-attribute.model';
import Project from 'models/project/project.model';
import { TicketAttributeService } from 'services/ticket-attribute/ticket-attribute.service';
import { ArcgisMapService } from 'services/arcgis-map/arcgis-map.service';

@Component({
  selector: 'app-create-ticket-attribute',
  templateUrl: './create-ticket-attribute.component.html',
  styleUrls: ['./create-ticket-attribute.component.scss'],
})
export class CreateTicketAttributeComponent {
  public instance: TicketAttribute = new TicketAttribute({ otherEnabled: 0 });
  public project: Project = new Project();
  public currentVal = '';
  public isArcgis = false;
  public isArcgisOn = false;

  constructor(
    public ticketAttributeService: TicketAttributeService,
    private dialogRef: MatDialogRef<CreateTicketAttributeComponent>,
    public arcgisMapService: ArcgisMapService,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.project = data.project;
    if (data.item) {
      this.instance = new TicketAttribute({
        ...data.item,
        project: data.project,
      });
    }
    this.instance.project = data.project;
    this.isArcgis = data.isArcgis;
  }

  setEnabled() {
    this.instance.otherEnabled = this.instance.otherEnabled === 0 ? 1 : 0;
  }

  setArcgisAttr(item: any, attr: any) {
    this.isArcgisOn = false;
    this.instance.ticketAttributeExtensions.push({ externalLayer: { url: item.url }, argisAttributeName: attr.name });
    this.instance.auto = true;
    this.instance.isDate = attr.type === 'date';
  }

  addValue() {
    if (this.currentVal.length > 0) {
      this.instance.possibleValues.push(this.currentVal);
      this.currentVal = '';
    }
  }

  setMulti() {
    this.instance.multi = !this.instance.multi;
    this.instance.isDate = false;
  }

  setIsDate() {
    this.instance.isDate = !this.instance.isDate;
    this.instance.multi = false;
    if (this.instance.isDate) {
      this.instance.possibleValues = [];
    }
  }

  deleteVal(val: string | { externalLayer: { url: string }, argisAttributeName: string }) {
    this.isArcgis
      ? this.instance.ticketAttributeExtensions = this.instance.ticketAttributeExtensions.filter(i => i !== val)
      : this.instance.possibleValues = this.instance.possibleValues.filter(i => i !== val);
  }

  async save() {
    if (this.instance.name.length !== 0 && (this.instance.ticketAttributeExtensions.length !== 0 || this.instance.possibleValues.length !== 0)) {
      if (this.instance.id.length > 0) {
        await this.ticketAttributeService.update(this.instance);
      } else {
        await this.ticketAttributeService.create(this.instance);
      }
      this.ticketAttributeService.selectList(this.project);
      this.dialogRef.close();
    }
  }
}
